import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import NotesAchievedModule from 'app_components/modules/campus/academic/notesAchieved'
import React, { FC, useMemo } from 'react'
import { useSelector } from 'react-redux'
import StudentDashboardCourseInformation, { StudentDashboardCourseInformationMode } from '../StudentDashboardCourseInformation/StudentDashboardCourseInformation'
import StudentDashboardCustomAccordion from '../StudentDashboardCustomAccordion/StudentDashboardCustomAccordion'
import StudentDashboardSelectCourse, { SelectCourseType } from '../StudentDashboardSelectCourse/StudentDashboardSelectCourse'
import { CombinedReducers } from 'app_events/index';

import './StudentsDashboardCurrentCourses.scss'
import StudentDashboardLearningPath from '../StudentDashboardLearningPath/StudentDashboardLearningPath'
import StudentDashboardCourseCriteria from '../StudentDashboardCourseCriteria/StudentDashboardCourseCriteria'
import { CourseSchedulingCourseType } from 'app_types/admin/courseScheduling/courseSchedulingTypes'
import DurationFieldService from 'app_services/components/durationFieldService'
import StudentDashboardCurrentStatus from '../StudentDashboardCurrentStatus/StudentDashboardCurrentStatus'

interface IStudentsDashboardCurrentCoursesProps {

}

const INFORMATION_MODES = [
  StudentDashboardCourseInformationMode.SCHEDULING,
  StudentDashboardCourseInformationMode.HISTORY,
  StudentDashboardCourseInformationMode.ACTIVITIES,
]

const typeCourseTranslation = {
  [CourseSchedulingCourseType.FREE]: "Curso Gratuito",
  [CourseSchedulingCourseType.MOOC]: "Mooc",
}

const StudentsDashboardCurrentCourses: FC<IStudentsDashboardCurrentCoursesProps> = () => {
  const { courseSelected } = useSelector((state: CombinedReducers) => state.courses)
  const durationFieldService = useMemo(() => new DurationFieldService(), [])
  const typeCourseText = courseSelected?.typeCourse ? typeCourseTranslation[courseSelected?.typeCourse] : null
  const isFreeOrMooc = courseSelected?.typeCourse ? [CourseSchedulingCourseType.FREE, CourseSchedulingCourseType.MOOC].includes(courseSelected?.typeCourse) : false

  return (
    <div className="students-dashboard-current-courses--layout">
      <StudentDashboardSelectCourse
        courseType={SelectCourseType.CURRENT}
        alertText='Aún no tienes cursos.'
      >
        <div className="students-dashboard-current-courses--content">
          <div>
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <TextComponent type='subtitle'>{courseSelected?.name ? courseSelected?.name : ''}</TextComponent>
              {typeCourseText?.length && (
                <span className='students-dashboard-current-courses--course-type'>
                  {typeCourseText}
                </span>
              )}
            </div>
            {isFreeOrMooc && (
              <div>
                <StudentDashboardCurrentStatus />
              </div>
            )}
            <div className='students-dashboard-current-courses--info-service'>
              <TextComponent fontSize='1.1rem'>ID: {courseSelected?.service_id}</TextComponent>
              <TextComponent fontSize='1.1rem'>Modalidad: {courseSelected?.schedulingMode?.name}</TextComponent>
            </div>
            {!!courseSelected?.serviceValidity && isFreeOrMooc && (
              <TextComponent fontSize='1.1rem'>Tiempo de vigencia: {durationFieldService.getDurationFormated(courseSelected.serviceValidity, 'large')}</TextComponent>
            )}
          </div>
          <StudentDashboardCustomAccordion>
            <StudentDashboardCourseCriteria />
          </StudentDashboardCustomAccordion>
          <StudentDashboardCustomAccordion>
            <StudentDashboardLearningPath id="student_dashboard_learning_path" toggleId='student_dashboard_learning_path_toggle' />
          </StudentDashboardCustomAccordion>
          <StudentDashboardCustomAccordion>
            <NotesAchievedModule id='student_dashboard_achieved_module' />
          </StudentDashboardCustomAccordion>
          <TextComponent type='subtitle'>Información del curso</TextComponent>
          <StudentDashboardCourseInformation modes={INFORMATION_MODES} />
        </div>
      </StudentDashboardSelectCourse>
    </div>
  )
}

export default StudentsDashboardCurrentCourses
